<template>
  <div class="page">
    <div class="page-header">
      <h1 class="page-title">WSGT Drive Campaign</h1>
      <breadcrumb name="WSGT_DRIVE_LIST"></breadcrumb>
      <div class="page-header-actions">
        <button
          type="button"
          @click="reloadTable"
          class="btn btn-icon btn-dark btn-outline btn-round mx-10"
        >
          <i class="icon md-refresh-alt" aria-hidden="true"></i> Reload table
        </button>
        <button
          type="button"
          class="btn btn-round btn-dark btn-outline mx-10"
          @click="hideArchive = !hideArchive"
        >
          {{ hideArchive ? "Show all" : "Hide Archive" }}
        </button>
        <button
          type="button"
          class="btn btn-round btn-primary"
          @click="addNewWSGTDrive"
        >
          <i class="icon md-plus" aria-hidden="true"></i> Create
        </button>
      </div>
    </div>
    <div class="page-content page-content-table">
      <div class="container-fluid">
        <div class="panel">
          <div class="panel-body p-0">
            <div class="vgt-global-search vgt-clearfix">
              <div class="vgt-global-search__input vgt-pull-left">
                <span class="input__icon">
                  <div class="magnifying-glass"></div>
                </span>
                <input
                  type="text"
                  placeholder="Search Table"
                  class="vgt-input vgt-pull-left"
                  v-model="searchTerm"
                  @keyup="handleSearchChange"
                />
              </div>
              <div class="vgt-global-search__actions vgt-pull-right"></div>
            </div>
            <vue-good-table
              ref="table"
              :rows="list"
              :columns="columns"
              @on-row-click="goToEdit"
              :sort-options="sortOption"
              :pagination-options="pagination"
              @on-sort-change="onSortChange"
              @on-page-change="onPageChange"
              @on-per-page-change="onPageChange"
              :search-options="{
                enabled: true,
                externalQuery: searchTerm,
              }"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'status'">
                  <span>
                    {{ props.row.status | toUpperCase }}
                  </span>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { wsgtdriveService } from "@/api/client";
import vueGoodTableMixins from "@/mixins/vue-good-table";
import { wsgtdriveTableColumns } from "@/views/wsgtdrive/model";

export default {
  name: "CampaignList",

  mixins: [vueGoodTableMixins],

  data() {
    return {
      list: [],
      campaigns: [],
      searchTerm: "",
      hideArchive: true,
      columns: wsgtdriveTableColumns,
    };
  },

  created() {
    this.fetch();
  },

  watch: {
    hideArchive() {
      this.filter();
    },

    campaigns(v) {
      this.list = v;
    },
  },

  beforeMount() {
    this.initialTableState();
  },

  mounted() {
    this.initialTableSearchState();
    this.searchTerm = this.$route.query.searchTerm;
  },

  methods: {
    goToEdit(event) {
      this.$router
        .push({ name: "WSGTDriveEdit", params: { id: event.row.id } })
        .catch((err) => {});
    },

    async fetch(show_all) {
      this.campaigns = await wsgtdriveService.getCampaignList({
        show_all: show_all,
      });
    },

    filter() {
      this.hideArchive ? this.fetch(0) : this.fetch(1);
    },

    async reloadTable() {
      await this.fetch();
      this.$notify("Updated");
    },

    async addNewWSGTDrive() {
      try {
        const result = await wsgtdriveService.createNewWSGTDrive();

        this.$router
          .push({ name: "WSGTDriveEdit", params: { id: result.id } })
          .catch((err) => {});
      } catch (error) {}
    },

    handleSearchChange() {
      this.onSearch({ searchTerm: this.searchTerm });
    },
  },
};
</script>

<style lang="scss">
table.vgt-table tr {
  cursor: pointer;
  &:hover {
    background-color: #f1f1f1;
  }
}
</style>
